export default __webpack_public_path__ + "static/media/logo-small.d9907649.jpg";